/* lono-upsell v14 */
(function () {
  if (window.__lonoUpsell) return;
  window.__lonoUpsell = true;

  /* Smooth cart updates and the add effects live in lono-cart-fx.js (loaded from the same place as this file). */
  try {
    var me = document.currentScript;
    if (me && me.src && !window.__lonoFx) {
      var fx = document.createElement('script');
      fx.src = me.src.replace('lono-upsell.js', 'lono-cart-fx.js');
      fx.defer = true;
      document.head.appendChild(fx);
    }
    if (me && me.src && !window.__lonoQty) {
      var qt = document.createElement('script');
      qt.src = me.src.replace('lono-upsell.js', 'lono-qb-qty.js');
      qt.defer = true;
      document.head.appendChild(qt);
    }
    if (me && me.src && !window.__lonoProt) {
      var pu = document.createElement('script');
      pu.src = me.src.replace('lono-upsell.js', 'lono-protect-ui.js');
      pu.defer = true;
      document.head.appendChild(pu);
    }
  } catch (e) {}

  var PROTECTION_PRODUCT_ID = 10806095184156;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var prev = null;

  function snapshot(cart) {
    var items = cart.items || [];
    var ship = items.filter(function (i) { return i.requires_shipping; })
      .reduce(function (s, i) { return s + i.final_line_price; }, 0);
    var disc = (cart.cart_level_discount_applications || [])
      .reduce(function (s, d) { return s + d.total_allocated_amount; }, 0);
    var prot = items.filter(function (i) { return i.product_id === PROTECTION_PRODUCT_ID; })
      .reduce(function (s, i) { return s + i.quantity; }, 0);
    var real = items.filter(function (i) { return i.product_id !== PROTECTION_PRODUCT_ID; });
    var keyVar = {};
    real.forEach(function (i) { keyVar[i.key] = i.variant_id; });
    return {
      total: ship - disc,
      keys: real.map(function (i) { return i.key; }),
      vars: real.map(function (i) { return i.variant_id; }),
      keyVar: keyVar,
      count: cart.item_count - prot,
      prot: prot
    };
  }

  /* A genuinely new product (not just a discounted/full-price split of a line already there). */
  function hasNewProduct(before, after) {
    return after.vars.some(function (v) { return before.vars.indexOf(v) < 0; });
  }

  /* The protection is a switch, not a product, so it should not add to the cart count. */
  function fixCounts() {
    if (!prev || !prev.prot) return;
    document.querySelectorAll('cart-count').forEach(function (el) {
      var n = parseInt(el.textContent, 10);
      if (n === prev.count + prev.prot) el.textContent = String(prev.count);
    });
  }
  var fixQueued = false;
  new MutationObserver(function () {
    if (fixQueued) return;
    fixQueued = true;
    requestAnimationFrame(function () { fixQueued = false; fixCounts(); });
  }).observe(document.documentElement, { subtree: true, childList: true, characterData: true });

  /* Free-shipping bar: the amount and the bar glide to the new value (no colour flash). */
  function tweenBar(drawer, before, after) {
    var bar = drawer.querySelector('free-shipping-bar');
    if (!bar) return;
    var threshold = parseFloat(bar.getAttribute('threshold'));
    if (!threshold) return;
    var accent = bar.querySelector('.text-accent');
    var fmt = bar._currencyFormatter;
    var progress = bar.querySelector('progress-bar');
    var t0 = Date.now(), dur = 700;
    (function step() {
      var k = Math.min(1, (Date.now() - t0) / dur);
      var e = 1 - Math.pow(1 - k, 3);
      var cur = before.total + (after.total - before.total) * e;
      if (accent && accent.isConnected && fmt) {
        accent.textContent = fmt.format(Math.max(0, threshold - cur) / 100);
      }
      if (progress) progress.style.setProperty('--progress', String(Math.min(1, Math.max(0, cur / threshold))));
      if (k < 1) requestAnimationFrame(step);
    })();
  }

  function bump() {
    document.querySelectorAll('cart-count').forEach(function (el) {
      el.classList.remove('lono-bump'); void el.offsetWidth; el.classList.add('lono-bump');
      setTimeout(function () { el.classList.remove('lono-bump'); }, 600);
    });
  }

  /* The size popup turns into an "added" sheet after adding; close it so the cart update is what the shopper sees. */
  function closePopup() {
    var cart = document.getElementById('cart-drawer');
    var qb = document.querySelector('quick-buy-drawer[open]');
    if (cart && cart.hasAttribute('open') && qb && typeof qb.hide === 'function') qb.hide();
  }

  function onChange(before, after) {
    fixCounts();
    if (hasNewProduct(before, after)) closePopup();
    if (reduce) return;
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    setTimeout(function () {
      var d = document.getElementById('cart-drawer');
      if (!d) return;
      /* glide the amount and bar on any change (adding or removing) */
      if (before.total !== after.total) tweenBar(d, before, after);
      if (hasNewProduct(before, after)) bump();
    }, 350);
  }

  /* Adding from the size popup inside the open cart: the cart updates behind it, so skip the "added" sheet. */
  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      var el = m.target;
      if (el.tagName === 'CART-NOTIFICATION-DRAWER' && el.hasAttribute('open')) {
        var drawer = document.getElementById('cart-drawer');
        if (drawer && drawer.hasAttribute('open') && typeof el.hide === 'function') el.hide();
      }
    });
  }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['open'] });

  document.addEventListener('cart:change', function (event) {
    var cart = event && event.detail && event.detail.cart;
    if (!cart || !cart.items) return;
    var before = prev;
    prev = snapshot(cart);
    /* Any add made while the cart is open (even one that only raises the quantity of a line already there) must not leave the "added" sheet on top. */
    if (event.detail.baseEvent === 'variant:add') closePopup();
    if (before) onChange(before, prev);
    else fixCounts();
  });

  /* Cart quantity: tap - / + instead of typing. The theme's selector changes the number; we send the update once after a short pause so quick taps make one request. */
  try {
    var qs = document.createElement('style');
    qs.textContent = 'line-item .lono-qty{height:34px;display:inline-flex;align-items:center;border:1px solid rgba(0,0,0,.25);border-radius:999px;background:#fff;overflow:hidden}' +
      'line-item .lono-qty .quantity-selector__button{width:34px;height:100%;padding:0;display:inline-flex;align-items:center;justify-content:center;cursor:pointer}' +
      'line-item .lono-qty .quantity-selector__button:active{background:rgba(0,0,0,.08)}' +
      'line-item .lono-qty .quantity-selector__input{width:30px;min-width:0;padding:0;border:0;text-align:center;font-weight:600;background:transparent;pointer-events:none}';
    document.head.appendChild(qs);
  } catch (e) {}
  document.addEventListener('click', function (event) {
    var b = event.target.closest && event.target.closest('line-item quantity-selector button');
    if (!b) return;
    var input = b.closest('quantity-selector').querySelector('input');
    if (input && input.dataset.lonoStart === undefined) input.dataset.lonoStart = input.value;
  }, true);
  document.addEventListener('click', function (event) {
    var b = event.target.closest && event.target.closest('line-item quantity-selector button');
    if (!b) return;
    var input = b.closest('quantity-selector').querySelector('input');
    if (!input) return;
    clearTimeout(input._lonoTimer);
    input._lonoTimer = setTimeout(function () {
      var start = input.dataset.lonoStart;
      delete input.dataset.lonoStart;
      if (start !== undefined && start !== input.value) input.dispatchEvent(new Event('change', { bubbles: true }));
    }, 500);
  });

  fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) { if (!prev) { prev = snapshot(cart); fixCounts(); } })
    .catch(function () {});
})();
